import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function InvoiceUploadForm() {
  const { setData, post, processing, errors, transform } = useForm<{
    files: File[];
  }>({
    files: [],
  });

  transform((data) => {
    return { draft_invoice: data };
  });

  function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();

    post(`/draft_invoices`, {
      preserveScroll: "errors",
    });
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="draft_invoice_files">Files</Label>
        <Input
          id="draft_invoice_files"
          type="file"
          onChange={(e) => setData("files", Array.from(e.target.files || []))}
          aria-invalid={!!errors.files}
          accept="application/pdf,image/*"
          multiple
        />
        {errors.files && (
          <p className="text-destructive text-sm">{errors.files}</p>
        )}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          Upload invoices
        </Button>
      </div>
    </form>
  );
}
